export default {
  root: {
    padding: '24px 16px 16px',
    '&.pt-4': {
      paddingTop: 28,
    },
  },
};
